import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconLogoutSvg }  from '../../assets/icons/icon_logout.svg';

const LogoutIcon=(props)=>{
    return <Icon component={() => <IconLogoutSvg />} {...props}/>
}

export default LogoutIcon;